import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

export const getPlans = () => axios.get(`${OCTOPUS_BASE_URL}/payments/plans`);
